import { useMe } from "@crehana/auth";
import { MembershipTypeMethod, UserDegreeSegmentationEnum } from "../../../__generated__/graphql-schema.js";
function useUserWithRoleAndPermissions() {
    const { me, loading } = useMe();
    const { isMentor, isProfessor, isAffiliate, isPremium, membership, hasOrganization, organization, userDegreeSegmentation } = me || {};
    const isAnonymous = !loading && !me;
    const isTeacher = !!isProfessor;
    const isDegreeStudent = userDegreeSegmentation === UserDegreeSegmentationEnum.ACTIVATED_DEGREE_SEGMENTATION;
    const { slug: organizationSlug, myRole: organizationRole } = organization || {};
    const isB2B = !!hasOrganization && !!organizationSlug;
    const isB2BAdmin = 'admin' === organizationRole || 'owner' === organizationRole || 'owner-corporation' === organizationRole;
    const isPAYG = !isAnonymous && !isMentor && !isTeacher && !isPremium && !isDegreeStudent && !isB2B && !isB2BAdmin;
    const hasInboxAccess = isMentor || isB2B || isTeacher || !!isPremium && membership?.membershipType?.method !== MembershipTypeMethod.A_2;
    return {
        me: {
            ...me,
            isAnonymous,
            isMentor: !!isMentor,
            isTeacher,
            isAffiliate: !!isAffiliate,
            isPremium: !!isPremium,
            isDegreeStudent,
            isB2B,
            isB2BAdmin,
            isPAYG,
            hasInboxAccess
        },
        loading
    };
}
const hooks_useUserWithRoleAndPermissions = useUserWithRoleAndPermissions;
export default hooks_useUserWithRoleAndPermissions;
